import React from "react";
import { Eye } from "react-feather";
import HtmlParser from "react-html-parser/lib/HtmlParser";
import { Link } from "react-router-dom";
import { Col, Card, CardImg, CardBody, CardTitle, CardText } from "reactstrap";

export const ItemTouristic = (props) => {
  const item = props.item;
  const route_atractive_detail = props.route.replace(":id", item.id);

  let itemDescription = item.description;
  if (itemDescription.length > 257) {
    itemDescription = `${item.description.substring(0, 257)} ..`;
  }
  if (itemDescription.includes("<p>")) {
    itemDescription = HtmlParser(itemDescription);
  }

  let titleItem = item.name;
  if (!titleItem) {
    titleItem = item.title;
  }

  let numberCols = props.ncol;
  if (!numberCols) {
    numberCols = "4";
  }

  let bgBtnColor = props.bgBtnColor;

  return (
    <Col sm={numberCols}>
      <Card className="card-item">
        <Link to={route_atractive_detail}>
          <CardImg
            alt="Card image cap"
            src={item.image}
            top
            width="100%"
            height="240px"
          />
        </Link>
        <CardBody>
          <div style={{ minHeight: "15em" }}>
            <CardTitle tag="h5" className="text-center">
              {titleItem}
            </CardTitle>
            <CardText className="card-text">{itemDescription}</CardText>
          </div>
          <div className="box-button-go-detail">
            <Link
              className="button-go-detail"
              style={{ backgroundColor: `${bgBtnColor}` }}
              to={route_atractive_detail}
            >
              Ver <Eye size="20" />
            </Link>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
